//
//
//
//
//
//
//
//
export default {
  name: 'Contextmenu',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    itemList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      left: 0,
      top: 0,
      target: null,
      selectedKeys: []
    };
  },
  computed: {
    style: function style() {
      return {
        left: this.left + 'px',
        top: this.top + 'px'
      };
    }
  },
  created: function created() {
    var _this = this;

    window.addEventListener('mousedown', function (e) {
      return _this.closeMenu(e);
    });
    window.addEventListener('contextmenu', function (e) {
      return _this.setPosition(e);
    });
  },
  methods: {
    closeMenu: function closeMenu(e) {
      if (['menuitemicon', 'menuitem'].indexOf(e.target.getAttribute('role')) < 0) {
        this.$emit('update:visible', false);
      }
    },
    setPosition: function setPosition(e) {
      this.left = e.clientX;
      this.top = e.clientY;
      this.target = e.target;
    },
    handleClick: function handleClick(_ref) {
      var key = _ref.key;
      this.$emit('select', key, this.target);
      this.$emit('update:visible', false);
    }
  }
};